// extracted by mini-css-extract-plugin
export var customDrawer = "CustomDrawer-module--customDrawer--43be2";
export var fullscreen = "CustomDrawer-module--fullscreen--84e64";
export var lmsScrollbar = "CustomDrawer-module--lms-scrollbar--1bdb9";
export var occupyMaxHeight = "CustomDrawer-module--occupyMaxHeight--a657d";